import Vue from 'vue';

export const onPageView = ({ eventId }) => {
    // UA
    Vue.$gtm.push({
        event: 'PageView',
        facebookEventID: eventId,
    });

    // GA4
    Vue.$gtm.push({
        event: 'view_item',
        facebookEventID: eventId,
    });
};
